import axios from '@/services/axios-config';
import NextAuth from 'next-auth';
import CredentialsProvider from 'next-auth/providers/credentials';

export const authOptions = {
  providers: [
    CredentialsProvider({
      type: 'credentials',
      async authorize(credentials) {
        const { username, password, user, token, rememberMe } = credentials;
        if (user) {
          try {
            const newUser = JSON.parse(user);
            delete newUser.addresses;
            return {
              user: newUser,
              token,
            };
          } catch (error) {
            throw new Error(`Login failed no credentials with ${error}`);
          }
        } else {
          try {
            const response = await axios({
              method: 'post',
              url: `${process.env.NEXT_PUBLIC_API_BASEURL}/customer/login`,
              data: {
                username,
                password,
              },
            });

            const user = {
              id: response?.data?.user?.id,
              store_id: response?.data?.user?.store_id,
              email: response?.data?.user?.email,
              firstname: response?.data?.user?.firstname,
              lastname: '',
              mobilenumber: response?.data?.user?.custom_attributes?.find(
                (attr) => attr.attribute_code === 'mobilenumber'
              )?.value,
              rememberMe,
            };

            const data = {
              user,
              token: response?.data?.token,
            };

            return data;
          } catch (error) {
            throw new Error('Login failed' + error?.message);
          }
        }
      },
    }),
  ],
  session: {
    maxAge: 1 * 24 * 60 * 60, // 1 HOUR -- 9 * 24 * 60 * 60  = 9 DAYS,
  },
  callbacks: {
    async jwt(xyz) {
      const { user, token } = xyz;
      if (user) {
        token.user = user?.user;
        token.mage = user?.token;
        // token.customExpires = new Date(
        //   user?.user?.rememberMe === false || user?.user?.rememberMe === 'false'
        //     ? Date.now() + 1 * 24 * 60 * 60 * 1000 // 1 day
        //     : Date.now() + 9 * 24 * 60 * 60 * 1000 // 9 days
        // );
      }
      return token;
    },
    async session(xyz) {
      const { session, token } = xyz;
      if (token) {
        session.user = token?.user;
        session.mage = token.mage;
        session.customExpires = token.customExpires;

        return session;
      }
      return session;
    },
  },
  // callbacks:{
  //   async redirect({url, baseUrl}){
  //     if (url.startsWith('/')) return `${baseUrl}${url}`;
  //     else if (new URL(url).origin === baseUrl) return url;
  //     return baseUrl;
  //   }
  // },
  pages: {
    signIn: '/login',
    // signout: '/',
  },
  secret: process.env.NEXTAUTH_SECRET,
  debug: process.env.NODE_ENV === 'development',
};

const handler = NextAuth(authOptions);

export { handler as GET, handler as POST };
